/**
 * Quote Validation API Service
 * Handles all quote validation-related API calls
 */
import { api } from './api.js'

const BASE_URL = '/api/quotes'

export const quoteValidationService = {
  /**
   * Get validation for a quote
   */
  get: (quoteId) => api.get(`${BASE_URL}/${quoteId}/validation`),

  /**
   * Check if quote has been validated
   */
  check: (quoteId) => api.get(`${BASE_URL}/${quoteId}/validation/check`),

  /**
   * Save validation (create or update)
   */
  save: (quoteId, validationData) =>
    api.post(`${BASE_URL}/${quoteId}/validation`, validationData),

  /**
   * Delete validation
   */
  delete: (quoteId) => api.delete(`${BASE_URL}/${quoteId}/validation`),

  /**
   * Get applicable questionnaires for a quote's formation
   */
  // formationCatalogueId lève l'ambiguïté entre deux formations de même nom :
  // optionnel, les demandes antérieures au champ n'en portent pas.
  getApplicableQuestionnaires: (formationNom, formationCategorie, formationCatalogueId = null) => {
    const params = new URLSearchParams({ formationNom, formationCategorie })
    if (formationCatalogueId) params.set('formationCatalogueId', formationCatalogueId)
    return api.get(`${BASE_URL}/questionnaires?${params.toString()}`)
  }
}
